/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Nutrition_MissingInputs */

const en_nutrition_missing = /** @type {(inputs: Nutrition_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not counted: ${i?.names}.`)
};

const de_nutrition_missing = /** @type {(inputs: Nutrition_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nicht berücksichtigt: ${i?.names}.`)
};

/**
* | output |
* | --- |
* | "Not counted: {names}." |
*
* @param {Nutrition_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_missing = /** @type {((inputs: Nutrition_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_missing(inputs)
	return en_nutrition_missing(inputs)
});